import { useState } from "react";
import RichTextEditor from "./richtext/RichTextEditor";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function AddPlan() {
    const [title, setTitle] = useState("");
    const [miniDescription, setMiniDescription] = useState("");
    const [description, setDescription] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            title: title,
            mini_description: miniDescription,
            description: description
        };
        try {
            await axiosPrivate.post(
                "/plans",
                payload,
                {headers: {Authorization: "Bearer " + auth.accessToken}}
            );
            navigate("/plans");
        } catch(err) {
            console.log(err);
        }
    }

    const initialSlateValue = [
        {
            type: 'paragraph',
            children: [{text: ''}]
        }
    ];

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                id="title"
                autoComplete="off"
                onChange={(e) => setTitle(e.target.value)}
                value={title}
                required
                placeholder="Title"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <input
                type="text"
                id="mini_description"
                autoComplete="off"
                value={miniDescription}
                onChange={(e) => setMiniDescription(e.target.value)}
                required
                placeholder="Mini Description"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <div className="pb-4">
                <RichTextEditor initialValue={initialSlateValue} setValue={setDescription} />
            </div>
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
};

export default AddPlan;